export default "__VITE_ASSET__HCu5$rpN__"